import { motion } from 'framer-motion';
import { Target, Lightbulb, Users } from 'lucide-react';

export const Mission = () => {
  return (
    <section className="section-padding bg-[#404041]" data-testid="mission-section">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-brand-light-green font-mono text-sm tracking-widest uppercase mb-4">
              Küldetésünk
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-6">
              Készségek, amelyek formálják az életed
            </h2>
            <div className="space-y-6 text-white/70 text-lg leading-relaxed">
              <p>
                Az Akadémia hisz abban, hogy a kommunikáció, az önismeret és a tudatos gondolkodás olyan készségek, amelyek nemcsak a karriert, hanem az egész életet formálják. Több mint 20 év tapasztalatával, gyakorlatközpontú tréningekkel segítünk, hogy a fejlődés ne elvont cél, hanem mérhető valóság legyen.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6"
          >
            {[
              {
                icon: Target,
                title: 'Gyakorlatközpontú megközelítés',
                desc: 'Nálunk nincs puszta elmélet. Minden tréning valós szituációkra épül, amelyeket te magad is átélsz és megoldasz.',
              },
              {
                icon: Lightbulb,
                title: 'Modern módszertan',
                desc: 'A legfrissebb kutatásokra és bevált technikákra építünk. Folyamatosan fejlesztjük programjainkat.',
              },
              {
                icon: Users,
                title: 'Személyre szabott figyelem',
                desc: 'Kis csoportokban dolgozunk, hogy minden résztvevő megkapja a kellő figyelmet és visszajelzést.',
              },
            ].map((item, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.6, delay: 0.3 + idx * 0.1 }}
                className="glass-card p-6 flex gap-5 hover:border-brand-light-blue/30 transition-colors duration-300"
              >
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#07516B]/20 flex items-center justify-center">
                    <item.icon size={24} className="text-[#56999B]" />
                  </div>
                </div>
                <div>
                  <h3 className="font-heading text-xl font-semibold text-white mb-2">{item.title}</h3>
                  <p className="text-white/60 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};
